module.exports = require("@swa-ui/browser/assets/styles/sass/defines/_mediaQueries.module.scss");